/**
 * This enum contains error codes to handle server error or url issues
 */
export enum ErrorHandlerCodesEnum {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVICE_UNAVAILABLE = 503,
}
